module.exports = __webpack_public_path__ + "media/images/preview_training_1-eb56c7d68b53acb63153edd860dc33ae.webp";